module.exports = __webpack_public_path__ + "static/media/SaumyaKumarThakur.82195930.jpg";